/**
 * @module lib/assetUrl
 * @description Resolves a public asset path against Vite's BASE_URL, and
 * passes data URLs (admin uploads) through untouched. Centralized so a
 * move to R2/CDN image hosting is a one-function change.
 */
export function assetUrl(src: string): string {
    if (/^(data:|blob:|https?:)/.test(src)) return src;
    return `${import.meta.env.BASE_URL}${src.replace(/^\//, "")}`;
}
